export default {
    user: {
      ID: 'User ID',
      username: 'Username',
      addressList: 'My Addresses',
      cart: 'My Shopping Cart',
      orderList: 'My orders'
    },

}



// WEBPACK FOOTER //
// ./src/Account/langs/en_us/index.js